import { Stack, Typography } from "@material-ui/core";
import { Box } from "@material-ui/system";
import { useState } from "react";
import arrowIcon from "src/assets/images/icon_arrow_right_white.svg";
import { DelegateTokenModal } from "src/modals/DelegateTokenModal";
import { StakingPoolItemModel } from "src/models/StakingPool";
import { CustomRouterLink } from "./CustomRouterLink";
import { StakingPoolItem } from "./StakingPoolItem";
import arrow_right from "src/assets/images/Arrow_right.svg"

export const StakingPools = (props: { pools: StakingPoolItemModel[] }) => {
  const [delegateModalVisible, setDelegateModalVisible] = useState(false);
  const [selectedPoolItem, setSelectedPoolItem] = useState<
    StakingPoolItemModel | undefined
  >(undefined);

  return (
    <Box p="50px 40px 74px">
      <Box display="flex" alignItems="center">
        <img src={arrow_right} style={{ width: "36px", height: "36px", marginRight: "10px" }} />
        <Typography fontSize="30px" variant="bold" color="#FFFFFF">
          Node Operator
        </Typography>
      </Box>
      <Box display="flex" alignItems="center" justifyContent="space-between">
        <Typography fontSize="16px" color="secondary" mt="15px">
          Delegate your token to Wetez and earn reward with APY shown below
        </Typography>
        <CustomRouterLink to="/stakingPools">
          <Box border="1px solid #C2C2C2" padding="9px 19px" display="flex" justifyContent="flex-end">
            <Stack direction="row">
              <Typography
                fontSize="16px"
                color="secondary"
                sx={{
                  textDecoration: "none",
                }}
              >
                See more
              </Typography>

              <Box width="7px" ml="8px">
                <img src={arrowIcon} width="100%" alt="icon" />
              </Box>
            </Stack>
          </Box>
        </CustomRouterLink>
      </Box>


      {/* <Box mt="34px">
        <Typography
          fontSize="16px"
          color="white"
          borderBottom="solid 1px white"
          sx={{
            display: "inline",
          }}
        >
          Mainnet
        </Typography>
      </Box> */}

      <Box
        mt="60px"
        sx={{
          display: "grid",
          gridTemplateColumns: "repeat(5, 200px)",
          rowGap: "50px",
          justifyContent: "space-between",
        }}
      >
        {props.pools.map((item) => (
          <StakingPoolItem
            key={item.nodeName}
            poolItem={item}
            onClickDelegate={() => {
              setSelectedPoolItem(item);
              setDelegateModalVisible(true);
            }}
          />
        ))}
      </Box>



      <DelegateTokenModal
        visible={delegateModalVisible}
        handleClose={() => setDelegateModalVisible(false)}
        poolItem={selectedPoolItem}
      />
    </Box>
  );
};
